import {useEffect} from 'react';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import AbstractProductModel from 'coreClasses/product/AbstractProductModel';
import ProductModel from 'coreClasses/product/ProductModel';

const useRefetchProducts = (products: AbstractProductModel[] = []) => {
	const {managerRepository} = useGeneralProvider();
	const productMgr = managerRepository.getProductsMgr();

	useEffect(() => {
		const pidsToRefetch = products.map((p) => p.getProductId());

		products.forEach((p) => {
			if (p.isVariationGroup() && p instanceof ProductModel) {
				pidsToRefetch.push(...p.getVariants().map((variant) => variant.getProductId()));
			}
		});

		productMgr.getProducts(pidsToRefetch, true);
	}, []);
};

export default useRefetchProducts;
